import React from 'react';
import styled from 'styled-components';
const ListContainer = styled.div `
  > div {
    &:last-child {
      border-bottom: none;
    }
  }
`;
export const List = ({ children }) => {
    return React.createElement(ListContainer, null, children);
};
//# sourceMappingURL=List.js.map